/* eslint-disable filetree-structure/services -- a part of the `playback`
service, imported by path rather than re-exported. The rule allows only
platform extensions beside the folder-named file. */
import * as ExpoCar from "$modules/expo-car";
import { isCarPlaySupported } from "$src/core/services/car/car";
import Logging from "$src/core/services/logging/logging";

/** Phone player ↔ car player coordination: iOS has one Now Playing slot, last-started surface wins. */

type PhonePlayerHandle = {
  pause: () => void;
};

let phonePlayer: PhonePlayerHandle | null = null;

export const registerPhonePlayer = (player: PhonePlayerHandle): void => {
  phonePlayer = player;
};

export const unregisterPhonePlayer = (player: PhonePlayerHandle): void => {
  if (phonePlayer === player) phonePlayer = null;
};

export const pausePhonePlayer = (): void => {
  phonePlayer?.pause();
};

/** Hands the car surface over to the phone player. */
export const notifyPhonePlaybackStarted = (): void => {
  if (!isCarPlaySupported) return;
  if (!ExpoCar.isConnected()) return;

  ExpoCar.stopPlayback().catch((error: unknown) => {
    Logging.error("Could not stop car playback", { error });
  });
  ExpoCar.showNowPlaying().catch((error: unknown) => {
    Logging.error("Could not show CarPlay Now Playing", { error });
  });
};
